import { defineQuery } from 'next-sanity'
import { inlineCtaFields } from '../atoms'

export const heroSliderBannerFields = `
  _id,
  _type,
  title,
  subtitle,
  images[],
  darkenImage,
  variant,
  description,
  badgeImage,
  "CTAButton": cta {
    ${inlineCtaFields}
  }
`

export const HERO_SLIDER_BANNER_QUERY = defineQuery(/* groq */ `
  *[_type == "hero-slider-banner"][0]{
    ${heroSliderBannerFields}
  }
`)
